<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container
    [observables]="[
        reminders$,
        reminderReviewPeriods$,
        reminderTypes$,
        recipients$,
        reminderScheduleTypes$,
        reminderStatus$,
        reminderGroups$
    ]"
></ef-loading-container>
<ef-reminder
    [process]="process$ | async"
    [items]="reminders$ | async"
    [reminderReviewPeriods]="reminderReviewPeriods$ | async"
    [reminderTypes]="reminderTypes$ | async"
    [recipients]="recipients$ | async"
    [reminderScheduleTypes]="reminderScheduleTypes$ | async"
    [reminderStatus]="reminderStatus$ | async"
    [selectedError]="selectedErrorWithStatus$ | async"
    [reminderGroups]="reminderGroups$ | async"
    (SaveReminder)="onSaveReminder($event)"
    (ApplyAction)="onApplyAction($event)"
    (RunNow)="onRunNow($event)"
    (ToggleReminders)="onToggleReminders($event)"
    (ShowError)="onShowError($event)"
    (ShowAdd)="showAddReminder = true"
></ef-reminder>
<ef-reminder-add
    #addReminder
    [reminderTypes]="reminderTypes$ | async"
    [reminderScheduleTypes]="reminderScheduleTypes$ | async"
    [recipients]="recipients$ | async"
    [reminderGroups]="reminderGroups$ | async"
    [reminderReviewPeriods]="reminderReviewPeriods$ | async"
    (Cancel)="CancelNewReminder()"
    (Save)="onAddReminder($event)"
    [show]="showAddReminder"
></ef-reminder-add>

<p-dialog
    #leaveRequestDialog
    header="Reminder"
    [(visible)]="showPopup"
    [maximizable]="false"
    [modal]="true"
    appendTo="body"
>
    <div *ngFor="let item of messages">{{ item }}</div>
    <ng-template #footer  class="button-bar button-bar-start padless">
        <button
            type="submit"
            pButton
            icon="pi pi-check"
            (click)="showPopup = false"
            label="Ok"
            id="btnSave"
            class="p-button-success"
        ></button>
    </ng-template>
</p-dialog>
